var monitorScroll = true;
var timeout;
const storeScroll = () => {
    if (monitorScroll){
        if (document.documentElement.dataset.scroll == 0 && window.scrollY > 0){
            monitorScroll = false;
            setTimeout(() => {
                monitorScroll = true;
                storeScroll();
            }, 800);
        }
        document.documentElement.dataset.scroll = window.scrollY;
    }
}
document.addEventListener('scroll', function() {
    if (timeout) {
        window.cancelAnimationFrame(timeout);
    }
    timeout = window.requestAnimationFrame(function() {
        storeScroll();
    });
},{ passive: true });
storeScroll();

if (window.__litium.constants.loggedInEmail){
    window.addEventListener('load', function() {
            setInterval(function(){
                fetch('/api/ping');
            }, 60000*10);
    });
}

var dropShipping = document.querySelector('.dropshipping-icon');
if (dropShipping)
{
    dropShipping.addEventListener('mousedown', function () {
        fetch('/api/dropshipping', {
            method: 'POST',
            headers: {
                'litium-request-context': JSON.stringify(window.__litium.requestContext),
            }
        })
            .then(response => {
                if (location.href.endsWith('.Login')) {
                    location.href = location.href.replace('.Login', '');
                }
                else {
                    location.reload();
                }
        });
    });
}

